/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-var */
/* tslint:disable */
/* eslint-disable prettier/prettier */

import { html, render } from "@rxdi/lit-html";
import { success } from "toastr";

import { CopyIcon } from "./markdown-reader/components/copy-icon";

/* http://prismjs.com/download.html?themes=prism-dark&languages=markup+css+clike+javascript+c+csharp+cpp+java+json+jsx+scss+typescript&plugins=show-language */

const _self =
 typeof window !== 'undefined'
  ? window // if in browser
  : typeof self['WorkerGlobalScope'] !== 'undefined'
  ? self // if in worker
  : {}; // if in node js

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 * MIT license http://www.opensource.org/licenses/mit-license.php/
 * @author Lea Verou http://lea.verou.me
 */

const Prism = (function () {
 // Private helper vars
 const lang = /\blang(?:uage)?-(\w+)\b/i;
 let uniqueId = 0;

 var _ = (_self['Prism'] = {
  util: {
   encode: function (tokens) {
    if (tokens instanceof Token) {
     return new Token(tokens['type'], _.util.encode(tokens['content']), tokens['alias']);
    } else if (_.util.type(tokens) === 'Array') {
     return tokens.map(_.util.encode);
    } else {
     return tokens
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/\u00a0/g, ' ');
    }
   },

   type: function (o) {
    return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
   },

   objId: function (obj) {
    if (!obj['__id']) {
     Object.defineProperty(obj, '__id', { value: ++uniqueId });
    }
    return obj['__id'];
   },

   // Deep clone a language definition (e.g. to extend it)
   clone: function (o) {
    const type = _.util.type(o);

    switch (type) {
     case 'Object':
      var clone = {};

      for (const key in o) {
       if (o.hasOwnProperty(key)) {
        clone[key] = _.util.clone(o[key]);
       }
      }

      return clone;

     case 'Array':
      // Check for existence for IE8
      return (
       o.map &&
       o.map(function (v) {
        return _.util.clone(v);
       })
      );
    }

    return o;
   },
  },

  languages: {
   extend: function (id, redef) {
    const lang = _.util.clone(_.languages[id]);

    for (const key in redef) {
     lang[key] = redef[key];
    }

    return lang;
   },

   /**
    * Insert a token before another token in a language literal
    * As this needs to recreate the object (we cannot actually insert before keys in object literals),
    * we cannot just provide an object, we need anobject and a key.
    * @param inside The key (or language id) of the parent
    * @param before The key to insert before. If not provided, the function appends instead.
    * @param insert Object with the key/value pairs to insert
    * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
    */
   insertBefore: function (inside, before, insert, root) {
    root = root || _.languages;
    const grammar = root[inside];

    if (arguments.length == 2) {
     // eslint-disable-next-line prefer-rest-params
     insert = arguments[1];

     for (var newToken in insert) {
      if (insert.hasOwnProperty(newToken)) {
       grammar[newToken] = insert[newToken];
      }
     }

     return grammar;
    }

    const ret = {};

    for (const token in grammar) {
     if (grammar.hasOwnProperty(token)) {
      if (token == before) {
       for (var newToken in insert) {
        if (insert.hasOwnProperty(newToken)) {
         ret[newToken] = insert[newToken];
        }
       }
      }

      ret[token] = grammar[token];
     }
    }

    // Update references in other language definitions
    _.languages.DFS(_.languages, function (key, value) {
     if (value === root[inside] && key != inside) {
      this[key] = ret;
     }
    });

    return (root[inside] = ret);
   },

   // Traverse a language definition with Depth First Search
   DFS: function (o, callback, type?, visited?) {
    visited = visited || {};
    for (const i in o) {
     if (o.hasOwnProperty(i)) {
      callback.call(o, i, o[i], type || i);

      if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
       visited[_.util.objId(o[i])] = true;
       _.languages.DFS(o[i], callback, null, visited);
      } else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
       visited[_.util.objId(o[i])] = true;
       _.languages.DFS(o[i], callback, i, visited);
      }
     }
    }
   },
  },
  plugins: {},
  highlightAll: function (async, callback) {
   _.highlightAllUnder(async, callback);
  },
  highlightAllUnder: function (async, callback) {
   const env = {
    callback: callback,
    selector:
     'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code',
   };

   _.hooks.run('before-highlightall', env);

   const elements = env['elements'] || document.querySelectorAll(env.selector);

   for (var i = 0, element; (element = elements[i++]); ) {
    _.highlightElement(element, async === true, env.callback);
   }
  },

  highlightElement: function (element, async, callback) {
   // Find language
   let language,
    grammar,
    parent = element;

   while (parent && !lang.test(parent.className)) {
    parent = parent.parentNode;
   }

   if (parent) {
    language = (parent.className.match(lang) || [, ''])[1].toLowerCase();
    grammar = _.languages[language];
   }

   // Set language on the element, if not present
   element.className =
    element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;

   // Set language on the parent, for styling
   parent = element.parentNode;

   if (/pre/i.test(parent.nodeName)) {
    parent.className =
     parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
   }

   const code = element.textContent;

   const env = {
    element: element,
    language: language,
    grammar: grammar,
    code: code,
   };

   _.hooks.run('before-sanity-check', env);

   if (!env.code || !env.grammar) {
    _.hooks.run('complete', env);
    return;
   }

   _.hooks.run('before-highlight', env);

   if (async && _self['Worker']) {
    const worker = new Worker(_['filename']);

    worker.onmessage = function (evt) {
     env['highlightedCode'] = evt.data;

     _.hooks.run('before-insert', env);

     env.element.innerHTML = env['highlightedCode'];

     callback && callback.call(env.element);
     _.hooks.run('after-highlight', env);
     _.hooks.run('complete', env);
    };

    worker.postMessage(
     JSON.stringify({
      language: env.language,
      code: env.code,
      immediateClose: true,
     }),
    );
   } else {
    env['highlightedCode'] = _.highlight(env.code, env.grammar, env.language);

    _.hooks.run('before-insert', env);

    env.element.innerHTML = env['highlightedCode'];

    callback && callback.call(element);

    _.hooks.run('after-highlight', env);
    _.hooks.run('complete', env);
   }
  },

  highlight: function (text, grammar, language) {
   const tokens = _.tokenize(text, grammar);
   return Token['stringify'](_.util.encode(tokens), language);
  },

  tokenize: function (text, grammar) {
   const Token = _['Token'];

   const strarr = [text];

   const rest = grammar.rest;

   if (rest) {
    for (var token in rest) {
     grammar[token] = rest[token];
    }

    delete grammar.rest;
   }

   tokenloop: for (var token in grammar) {
    if (!grammar.hasOwnProperty(token) || !grammar[token]) {
     continue;
    }

    let patterns = grammar[token];
    patterns = _.util.type(patterns) === 'Array' ? patterns : [patterns];

    for (let j = 0; j < patterns.length; ++j) {
     let pattern = patterns[j];
     let lookbehindLength = 0;
     const
      inside = pattern.inside,
      lookbehind = !!pattern.lookbehind,
      greedy = !!pattern.greedy,
      
      alias = pattern.alias;

     if (greedy && !pattern.pattern.global) {
      // Without the global flag, lastIndex won't work
      const flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
      pattern.pattern = RegExp(pattern.pattern.source, flags + 'g');
     }

     pattern = pattern.pattern || pattern;

     // Don’t cache length as it changes during the loop
     for (let i = 0, pos = 0; i < strarr.length; pos += strarr[i].length, ++i) {
      let str = strarr[i];

      if (strarr.length > text.length) {
       // Something went terribly wrong, ABORT, ABORT!
       break tokenloop;
      }

      if (str instanceof Token) {
       continue;
      }

      pattern.lastIndex = 0;

      var match = pattern.exec(str),
       delNum = 1;

      // Greedy patterns can override/remove up to two previously matched tokens
      if (!match && greedy && i != strarr.length - 1) {
       pattern.lastIndex = pos;
       match = pattern.exec(text);
       if (!match) {
        break;
       }

       var from = match.index + (lookbehind ? match[1].length : 0),
        to = match.index + match[0].length,
        k = i,
        p = pos;

       for (let len = strarr.length; k < len && p < to; ++k) {
        p += strarr[k].length;
        // Move the index i to the element in strarr that is closest to from
        if (from >= p) {
         ++i;
         pos = p;
        }
       }

       /*
        * If strarr[i] is a Token, then the match starts inside another Token, which is invalid
        * If strarr[k - 1] is greedy we are in conflict with another greedy pattern
        */
       if (strarr[i] instanceof Token || strarr[k - 1].greedy) {
        continue;
       }

       // Number of tokens to delete and replace with the new match
       delNum = k - i;
       str = text.slice(pos, p);
       match.index -= pos;
      }

      if (!match) {
       continue;
      }

      if (lookbehind) {
       lookbehindLength = match[1].length;
      }

      var from = match.index + lookbehindLength,
       match = match[0].slice(lookbehindLength),
       to = from + match.length,
       before = str.slice(0, from),
       after = str.slice(to);

      const args = [i, delNum];

      if (before) {
       args.push(before);
      }

      const wrapped = new Token(
       token,
       inside ? _.tokenize(match, inside) : match,
       alias,
       match,
       greedy,
      );

      args.push(wrapped);

      if (after) {
       args.push(after);
      }

      Array.prototype.splice.apply(strarr, args);
     }
    }
   }

   return strarr;
  },

  hooks: {
   all: {},

   add: function (name, callback) {
    const hooks = _.hooks.all;

    hooks[name] = hooks[name] || [];

    hooks[name].push(callback);
   },

   run: function (name, env) {
    const callbacks = _.hooks.all[name];

    if (!callbacks || !callbacks.length) {
     return;
    }

    for (var i = 0, callback; (callback = callbacks[i++]); ) {
     callback(env);
    }
   },
  },
 });

 var Token = (_['Token'] = function (type, content, alias?, matchedStr?, greedy?) {
  this.type = type;
  this.content = content;
  this.alias = alias;
  // Copy of the full string this token was created from
  this.length = (matchedStr || '').length | 0;
  this.greedy = !!greedy;
 });

 Token['stringify'] = function (o, language, parent) {
  if (typeof o == 'string') {
   return o;
  }

  if (_.util.type(o) === 'Array') {
   return o
    .map(function (element) {
     return Token['stringify'](element, language, o);
    })
    .join('');
  }

  const env = {
   type: o.type,
   content: Token['stringify'](o.content, language, parent),
   tag: 'span',
   classes: ['token', o.type],
   attributes: {},
   language: language,
   parent: parent,
  };

  if (env.type == 'comment') {
   env.attributes['spellcheck'] = 'true';
  }

  if (o.alias) {
   const aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
   Array.prototype.push.apply(env.classes, aliases);
  }

  _.hooks.run('wrap', env);

  let attributes = '';

  for (const name in env.attributes) {
   attributes +=
    (attributes ? ' ' : '') + name + '="' + (env.attributes[name] || '') + '"';
  }

  return (
   '<' +
   env.tag +
   ' class="' +
   env.classes.join(' ') +
   '"' +
   (attributes ? ' ' + attributes : '') +
   '>' +
   env.content +
   '</' +
   env.tag +
   '>'
  );
 };

 if (!_self['document']) {
  if (!_self['addEventListener']) {
   // in Node.js
   return _self['Prism'];
  }
  // In worker
  _self['addEventListener'](
   'message',
   function (evt) {
    const message = JSON.parse(evt.data),
     lang = message.language,
     code = message.code,
     immediateClose = message.immediateClose;

    _self['postMessage'](_.highlight(code, _.languages[lang], lang));
    if (immediateClose) {
     _self['close']();
    }
   },
   false,
  );

  return _self['Prism'];
 }

 //Get current script and highlight
 const script =
  document.currentScript || [].slice.call(document.getElementsByTagName('script')).pop();

 if (script) {
  _['filename'] = script.src;

  if (document.addEventListener && !script.hasAttribute('data-manual')) {
   if (document.readyState !== 'loading') {
    if (window.requestAnimationFrame) {
     window.requestAnimationFrame(_.highlightAll as never);
    } else {
     window.setTimeout(_.highlightAll, 16);
    }
   } else {
    document.addEventListener('DOMContentLoaded', _.highlightAll as never);
   }
  }
 }

 return _self['Prism'];
})();


Prism.languages.markup = {
 comment: /<!--[\w\W]*?-->/,
 prolog: /<\?[\w\W]+?\?>/,
 doctype: /<!DOCTYPE[\w\W]+?>/i,
 cdata: /<!\[CDATA\[[\w\W]*?]]>/i,
 tag: {
  pattern: /<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i,
  inside: {
   tag: {
    pattern: /^<\/?[^\s>\/]+/i,
    inside: {
     punctuation: /^<\/?/,
     namespace: /^[^\s>\/:]+:/,
    },
   },
   'attr-value': {
    pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/i,
    inside: {
     punctuation: /[=>"']/,
    },
   },
   punctuation: /\/?>/,
   'attr-name': {
    pattern: /[^\s>\/]+/,
    inside: {
     namespace: /^[^\s>\/:]+:/,
    },
   },
  },
 },
 entity: /&#?[\da-z]{1,8};/i,
};

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {
 if (env.type === 'entity') {
  env.attributes['title'] = env.content.replace(/&amp;/, '&');
 }
});

Prism.languages.xml = Prism.languages.markup;
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.css = {
 comment: /\/\*[\w\W]*?\*\//,
 atrule: {
  pattern: /@[\w-]+?.*?(;|(?=\s*\{))/i,
  inside: {
   rule: /@[\w-]+/,
   // See rest below
  },
 },
 url: /url\((?:(["'])(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
 selector: /[^\{\}\s][^\{\};]*?(?=\s*\{)/,
 string: {
  pattern: /("|')(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1/,
  greedy: true,
 },
 property: /(\b|\B)[\w-]+(?=\s*:)/i,
 important: /\B!important\b/i,
 function: /[-a-z0-9]+(?=\()/i,
 punctuation: /[(){};:]/,
};

Prism.languages.css['atrule'].inside.rest = Prism.util.clone(Prism.languages.css);

if (Prism.languages.markup) {
 Prism.languages.insertBefore('markup', 'tag', {
  style: {
   pattern: /(<style[\w\W]*?>)[\w\W]*?(?=<\/style>)/i,
   lookbehind: true,
   inside: Prism.languages.css,
   alias: 'language-css',
  },
 });

 Prism.languages.insertBefore(
  'inside',
  'attr-value',
  {
   'style-attr': {
    pattern: /\s*style=("|').*?\1/i,
    inside: {
     'attr-name': {
      pattern: /^\s*style/i,
      inside: Prism.languages.markup.tag.inside,
     },
     punctuation: /^\s*=\s*['"]|['"]\s*$/,
     'attr-value': {
      pattern: /.+/i,
      inside: Prism.languages.css,
     },
    },
    alias: 'language-css',
   },
  },
  Prism.languages.markup.tag,
 );
}
Prism.languages.clike = {
 comment: [
  {
   pattern: /(^|[^\\])\/\*[\w\W]*?\*\//,
   lookbehind: true,
  },
  {
   pattern: /(^|[^\\:])\/\/.*/,
   lookbehind: true,
  },
 ],
 string: {
  pattern: /(["'])(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
  greedy: true,
 },
 'class-name': {
  pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/i,
  lookbehind: true,
  inside: {
   punctuation: /(\.|\\)/,
  },
 },
 keyword: /\b(if|else|async|await|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
 boolean: /\b(true|false)\b/,
 function: /[a-z0-9_]+(?=\()/i,
 number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
 operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
 punctuation: /[{}[\];(),.:]/,
};

Prism.languages.javascript = Prism.languages.extend('clike', {
 keyword: /\b(as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
 number: /\b-?(0x[\dA-Fa-f]+|0b[01]+|0o[0-7]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|Infinity)\b/,
 // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
 function: /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\()/i,
 operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*\*?|\/|~|\^|%|\.{3}/,
});

Prism.languages.insertBefore('javascript', 'keyword', {
 regex: {
  pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\\\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
  lookbehind: true,
  greedy: true,
 },
});

Prism.languages.insertBefore('javascript', 'string', {
 'template-string': {
  pattern: /`(?:\\\\|\\?[^\\])*?`/,
  greedy: true,
  inside: {
   interpolation: {
    pattern: /\$\{[^}]+\}/,
    inside: {
     'interpolation-punctuation': {
      pattern: /^\$\{|\}$/,
      alias: 'punctuation',
     },
     rest: Prism.languages.javascript,
    },
   },
   string: /[\s\S]+/,
  },
 },
});

if (Prism.languages.markup) {
 Prism.languages.insertBefore('markup', 'tag', {
  script: {
   pattern: /(<script[\w\W]*?>)[\w\W]*?(?=<\/script>)/i,
   lookbehind: true,
   inside: Prism.languages.javascript,
   alias: 'language-javascript',
  },
 });
}

Prism.languages.js = Prism.languages.javascript;
Prism.languages.c = Prism.languages.extend('clike', {
 keyword: /\b(asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
 operator: /\-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*\/]/,
 number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)[ful]*\b/i,
});

Prism.languages.insertBefore('c', 'string', {
 macro: {
  // allow for multiline macro definitions
  // spaces after the # character compile fine with gcc
  pattern: /(^\s*)#\s*[a-z]+([^\r\n\\]|\\.|\\(?:\r\n?|\n))*/im,
  lookbehind: true,
  alias: 'property',
  inside: {
   // highlight the path of the include statement as a string
   string: {
    pattern: /(#\s*include\s*)(<.+?>|("|')(\\?.)+?\3)/,
    lookbehind: true,
   },
   // highlight macro directives as keywords
   directive: {
    pattern: /(#\s*)\b(define|elif|else|endif|error|ifdef|ifndef|if|import|include|line|pragma|undef|using)\b/,
    lookbehind: true,
    alias: 'keyword',
   },
  },
 },
 // highlight predefined macros as constants
 constant: /\b(__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|stdin|stdout|stderr)\b/,
});

delete Prism.languages.c['class-name'];
delete Prism.languages.c['boolean'];

Prism.languages.csharp = Prism.languages.extend('clike', {
 keyword: /\b(abstract|as|async|await|base|bool|break|byte|case|catch|char|checked|class|const|continue|decimal|default|delegate|do|double|else|enum|event|explicit|extern|false|finally|fixed|float|for|foreach|goto|if|implicit|in|int|interface|internal|is|lock|long|namespace|new|null|object|operator|out|override|params|private|protected|public|readonly|ref|return|sbyte|sealed|short|sizeof|stackalloc|static|string|struct|switch|this|throw|true|try|typeof|uint|ulong|unchecked|unsafe|ushort|using|virtual|void|volatile|while|add|alias|ascending|async|await|descending|dynamic|from|get|global|group|into|join|let|orderby|partial|remove|select|set|value|var|where|yield)\b/,
 string: [/@("|')(\1\1|\\\1|\\?(?!\1)[\s\S])*\1/, /("|')(\\?.)*?\1/],
 number: /\b-?(0x[\da-f]+|\d*\.?\d+f?)\b/i,
});

Prism.languages.insertBefore('csharp', 'keyword', {
 'generic-method': {
  pattern: /[a-z0-9_]+\s*<[^>\r\n]+?>\s*(?=\()/i,
  alias: 'function',
  inside: {
   keyword: Prism.languages.csharp.keyword,
   punctuation: /[<>(),.:]/,
  },
 },
 preprocessor: {
  pattern: /(^\s*)#.*/m,
  lookbehind: true,
  alias: 'property',
  inside: {
   // highlight preprocessor directives as keywords
   directive: {
    pattern: /(\s*#)\b(define|elif|else|endif|endregion|error|if|line|pragma|region|undef|warning)\b/,
    lookbehind: true,
    alias: 'keyword',
   },
  },
 },
});

Prism.languages.cpp = Prism.languages.extend('c', {
 keyword: /\b(alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|class|compl|const|constexpr|const_cast|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|float|for|friend|goto|if|inline|int|long|mutable|namespace|new|noexcept|nullptr|operator|private|protected|public|register|reinterpret_cast|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
 boolean: /\b(true|false)\b/,
 operator: /[-+]{1,2}|!=?|<{1,2}=?|>{1,2}=?|\->|:{1,2}|={1,2}|\^|~|%|&{1,2}|\|?\||\?|\*|\/|\b(and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
});

Prism.languages.insertBefore('cpp', 'keyword', {
 'class-name': {
  pattern: /(class\s+)[a-z0-9_]+/i,
  lookbehind: true,
 },
});
Prism.languages.java = Prism.languages.extend('clike', {
 keyword: /\b(abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while)\b/,
 number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp\-]+\b|\b\d*\.?\d+(?:e[+-]?\d+)?[df]?\b/i,
 operator: {
  pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
  lookbehind: true,
 },
});

Prism.languages.insertBefore('java', 'function', {
 annotation: {
  alias: 'punctuation',
  pattern: /(^|[^.])@\w+/,
  lookbehind: true,
 },
});

Prism.languages.insertBefore('graphql', 'function', {
 annotation: {
  lookbehind: true,
 },
});


Prism.languages.json = {
 property: /"(?:\\.|[^|"])*"(?=\s*:)/gi,
 string: /"(?!:)(?:\\.|[^|"])*"(?!:)/g,
 number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee][+-]?\d+)?)\b/g,
 punctuation: /[{}[\]);,]/g,
 operator: /:/g,
 boolean: /\b(true|false)\b/gi,
 null: /\bnull\b/gi,
};

Prism.languages.jsonp = Prism.languages.json;

(function (Prism) {
 const javascript = Prism.util.clone(Prism.languages.javascript);

 Prism.languages.jsx = Prism.languages.extend('markup', javascript);
 Prism.languages.jsx.tag.pattern = /<\/?[\w\.:-]+\s*(?:\s+[\w\.:-]+(?:=(?:("|')(\\?[\w\W])*?\1|[^\s'">=]+|(\{[\w\W]*?\})))?\s*)*\/?>/i;

 Prism.languages.jsx.tag.inside[
  'attr-value'
 ].pattern = /=[^\{](?:('|")[\w\W]*?(\1)|[^\s>]+)/i;

 let jsxExpression = Prism.util.clone(Prism.languages.jsx);

 delete jsxExpression.punctuation;

 jsxExpression = Prism.languages.insertBefore(
  'jsx',
  'operator',
  {
   punctuation: /=(?={)|[{}[\];(),.:]/,
  },
  { jsx: jsxExpression },
 );

 Prism.languages.insertBefore(
  'inside',
  'attr-value',
  {
   script: {
    // Allow for one level of nesting
    pattern: /=(\{(?:\{[^}]*\}|[^}])+\})/i,
    inside: jsxExpression,
    alias: 'language-javascript',
   },
  },
  Prism.languages.jsx.tag,
 );
})(Prism);

Prism.languages.scss = Prism.languages.extend('css', {
 comment: {
  pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|\/\/.*)/,
  lookbehind: true,
 },
 atrule: {
  pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
  inside: {
   rule: /@[\w-]+/,
   // See rest below
  },
 },
 // url, compassified
 url: /(?:[-a-z]+-)*url(?=\()/i,
 // CSS selector regex is not appropriate for Sass
 // since there can be lot more things (var, @ directive, nesting..)
 // a selector must start at the end of a property or after a brace (end of other rules or nesting)
 // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
 // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
 // can "pass" as a selector- e.g: proper#{$erty})
 // this one was hard to do, so please be careful if you edit this one :)
 selector: {
  // Initial look-ahead is used to prevent matching of blank selectors
  pattern: /(?=\S)[^@;\{\}\(\)]?([^@;\{\}\(\)]|&|#\{\$[-_\w]+\})+(?=\s*\{(\}|\s|[^\}]+(:|\{)[^\}]+))/m,
  inside: {
   parent: {
    pattern: /&/,
    alias: 'important',
   },
   placeholder: /%[-_\w]+/,
   variable: /\$[-_\w]+|#\{\$[-_\w]+\}/,
  },
 },
});

Prism.languages.insertBefore('scss', 'atrule', {
 keyword: [
  /@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i,
  {
   pattern: /( +)(?:from|through)(?= )/,
   lookbehind: true,
  },
 ],
});

Prism.languages.scss.property = {
 pattern: /(?:[\w-]|\$[-_\w]+|#\{\$[-_\w]+\})+(?=\s*:)/i,
 inside: {
  variable: /\$[-_\w]+|#\{\$[-_\w]+\}/,
 },
};

Prism.languages.insertBefore('scss', 'important', {
 // var and interpolated vars
 variable: /\$[-_\w]+|#\{\$[-_\w]+\}/,
});

Prism.languages.insertBefore('scss', 'function', {
 placeholder: {
  pattern: /%[-_\w]+/,
  alias: 'selector',
 },
 statement: {
  pattern: /\B!(?:default|optional)\b/i,
  alias: 'keyword',
 },
 boolean: /\b(?:true|false)\b/,
 null: /\bnull\b/,
 operator: {
  pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
  lookbehind: true,
 },
});

Prism.languages.scss['atrule'].inside.rest = Prism.util.clone(Prism.languages.scss);
Prism.languages.typescript = Prism.languages.extend('javascript', {
 keyword: /\b(break|case|async|await|readonly|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|function|get|if|implements|import|in|instanceof|interface|let|new|null|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield|module|declare|constructor|string|Function|any|number|boolean|Array|enum)\b/,
});

(function () {
 if (typeof self === 'undefined' || !self['Prism'] || !self.document) {
  return;
 }

 // The languages map is built automatically with gulp
 const Languages = /*languages_placeholder[*/ {
  html: 'HTML',
  xml: 'XML',
  svg: 'SVG',
  mathml: 'MathML',
  css: 'CSS',
  clike: 'C-like',
  javascript: 'JavaScript',
  abap: 'ABAP',
  actionscript: 'ActionScript',
  apacheconf: 'Apache Configuration',
  apl: 'APL',
  applescript: 'AppleScript',
  asciidoc: 'AsciiDoc',
  aspnet: 'ASP.NET (C#)',
  autoit: 'AutoIt',
  autohotkey: 'AutoHotkey',
  basic: 'BASIC',
  csharp: 'C#',
  cpp: 'C++',
  coffeescript: 'CoffeeScript',
  'css-extras': 'CSS Extras',
  fsharp: 'F#',
  glsl: 'GLSL',
  graphql: 'GraphQL',
  http: 'HTTP',
  inform7: 'Inform 7',
  json: 'JSON',
  latex: 'LaTeX',
  livescript: 'LiveScript',
  lolcode: 'LOLCODE',
  matlab: 'MATLAB',
  mel: 'MEL',
  nasm: 'NASM',
  nginx: 'nginx',
  nsis: 'NSIS',
  objectivec: 'Objective-C',
  ocaml: 'OCaml',
  parigp: 'PARI/GP',
  php: 'PHP',
  'php-extras': 'PHP Extras',
  powershell: 'PowerShell',
  properties: '.properties',
  protobuf: 'Protocol Buffers',
  jsx: 'React JSX',
  rest: 'reST (reStructuredText)',
  sas: 'SAS',
  sass: 'Sass (Sass)',
  scss: 'Sass (Scss)',
  sql: 'SQL',
  typescript: 'TypeScript',
  vhdl: 'VHDL',
  vim: 'vim',
  wiki: 'Wiki markup',
  xojo: 'Xojo (REALbasic)',
  yaml: 'YAML',
 }; /*]*/
 Prism.hooks.add('before-highlight', function (env) {
  const pre = env.element.parentNode;
  if (!pre || !/pre/i.test(pre.nodeName)) {
   return;
  }
  const language =
   pre.getAttribute('data-language') ||
   Languages[env.language] ||
   env.language.substring(0, 1).toUpperCase() + env.language.substring(1);

  /* check if the divs already exist */
  const sib = pre.previousSibling;
  let div, div2, div3;
  if (
   sib &&
   /\s*\bprism-show-language\b\s*/.test(sib.className) &&
   sib.firstChild &&
   /\s*\bprism-show-language-label\b\s*/.test(sib.firstChild.className)
  ) {
   div2 = sib.firstChild;
  } else {
   div = document.createElement('div');
   div2 = document.createElement('div');
   div3 = document.createElement('div');

   div2.className = 'prism-show-language-label';

   div.className = 'prism-show-language code-label';
   div.appendChild(div2);
  //  render(html`
  //     <div class="copy-icon" @click=${function(this: HTMLElement) {
  //     navigator.clipboard.writeText(this.parentElement.nextSibling.firstChild.firstChild.textContent);

  //   success('Code added to clipboard', 'Copy Success');
  //     }}>${CopyIcon}</div>
  //  `,div)

   pre.parentNode.insertBefore(div, pre);
  }

  div2.innerHTML = language;
 });
})();
